"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function intlLibraryIsPresent() {
    return !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function');
}
exports.default = intlLibraryIsPresent;
